import { Routes, Route, Navigate } from 'react-router-dom';

import AppLayout from './components/layout/AppLayout.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';

import Login from './pages/auth/Login.jsx';
import Signup from './pages/auth/Signup.jsx';

import Landing from './pages/marketing/Landing.jsx';
import TodaysBrief from './pages/subscriber/TodaysBrief.jsx';
import Archive from './pages/subscriber/Archive.jsx';
import ArchiveEdition from './pages/subscriber/ArchiveEdition.jsx';
import Referrals from './pages/subscriber/Referrals.jsx';

import AdminEditor from './pages/admin/editor/Editor.jsx';
import AdminLayout from './pages/admin/AdminLayout.jsx';
import AdminSourcesSection from './pages/admin/sections/Sources.jsx';
import AdminKeywords from './pages/admin/sections/Keywords.jsx';
import AdminReferrals from './pages/admin/sections/Referrals.jsx';
import AdminFeedback from './pages/admin/sections/Feedback.jsx';
import DevLanding from './pages/admin/dev/DevLanding.jsx';
import Prompts from './pages/admin/dev/Prompts.jsx';
import PromptEditor from './pages/admin/dev/PromptEditor.jsx';
import DevSources from './pages/admin/dev/Sources.jsx';
import Runs from './pages/admin/dev/Runs.jsx';
import RunDetail from './pages/admin/dev/RunDetail.jsx';
import Feedback from './pages/admin/dev/Feedback.jsx';
import WelcomeLanding from './pages/marketing/WelcomeLanding.jsx';
import RefLanding from './pages/marketing/RefLanding.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/ref/:code" element={<RefLanding />} />

      {/* Public landing — full-bleed hero takeover, outside AppLayout so
          the site header/footer don't break the design. Landing.jsx redirects
          unauthenticated visitors here from /. */}
      <Route path="/welcome" element={<WelcomeLanding />} />

      <Route element={<AppLayout />}>
        <Route index element={<Landing />} />
        <Route path="/today" element={<TodaysBrief />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/archive/:date" element={<ArchiveEdition />} />

        {/* Any authenticated user */}
        <Route element={<ProtectedRoute />}>
          <Route path="/referrals" element={<Referrals />} />
        </Route>

        {/* Editor + dev only */}
        <Route element={<ProtectedRoute role="editor" />}>
          <Route path="/admin/editor" element={<AdminEditor />} />
          <Route path="/admin/editor/:date" element={<AdminEditor />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="sources" replace />} />
            <Route path="sources" element={<AdminSourcesSection />} />
            <Route path="keywords" element={<AdminKeywords />} />
            <Route path="referrals" element={<AdminReferrals />} />
            <Route path="feedback" element={<AdminFeedback />} />
          </Route>
        </Route>

        {/* Dev only */}
        <Route element={<ProtectedRoute role="dev" />}>
          <Route path="/admin/dev" element={<DevLanding />} />
          <Route path="/admin/dev/prompts" element={<Prompts />} />
          <Route path="/admin/dev/prompts/:name" element={<PromptEditor />} />
          <Route path="/admin/dev/sources" element={<DevSources />} />
          <Route path="/admin/dev/runs" element={<Runs />} />
          <Route path="/admin/dev/runs/:id" element={<RunDetail />} />
          <Route path="/admin/dev/feedback" element={<Feedback />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
